import React from 'react';
import {observer} from 'mobx-react';
import ModalSimple from '../../../global/modal-simple';

@observer
export default class ModalFastShipping extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <ModalSimple
                id="modal-fast-shipping"
                title={'Fast Shipping Not Applied!'}
            >
                <div>
                    Warning!
                    <i
                        className="fas fa-exclamation-triangle fa-2x"
                        style={{float: 'right'}}
                        aria-hidden={true}
                    />
                    <p style={{marginTop: 12}}>Your shopping cart contains items that do not qualify for fast shipping. One of the items in your cart qualifies for fast shipping.</p>
                    <p style={{marginTop: 12}}>
                        Our fast shipping items must be ordered together, as we do not ship items separately. To ensure accelerated delivery dates, please place a separate order for any items that qualify for fast shipping, otherwise your order will default to the standard ground shipping in-hands
                        window.
                    </p>
                    <p style={{marginTop: 12}}>Items that qualify for fast shipping are marked with yellow 'FAST SHIPPING' labels.</p>
                </div>
            </ModalSimple>
        );
    }
}
